import React, { useMemo } from 'react';
import classnames from 'classnames';
import styles from './knowledge-hub.module.scss';
import { KnowledgeHubProvider, useKnowledgeHub } from './hooks/use-knowledge-hub.hooks';
import { RenderOrganizationList } from './components/render-organization-list';
import { HubSearch } from './components/hub-search';
import { RenderContent } from './components/render-content';
import { RenderHeader } from './components/render-header';
import { HubContentBanner } from './components/hub-content-banner';
import analyticsService from 'src/helpers/analytics.service';
import { EVENTS } from 'shared/constants';

function HubPageContent() {
  const { selectedOrganization } = useKnowledgeHub();

  return (
    <>
      {selectedOrganization && <HubContentBanner />}
      <div className={classnames([styles.root, 'new-design-system'])}>
        <RenderHeader />
        <HubSearch />
        <RenderOrganizationList />
        <RenderContent />
      </div>
    </>
  );
}

export function KnowledgeHubPage() {
  const analyticsTriggers = useMemo(
    () => ({
      onPageLoad: payload => analyticsService.track(EVENTS.KNOWLEDGE_HUB.OPEN, payload),
      onSelectOrganization: payload =>
        analyticsService.track(EVENTS.KNOWLEDGE_HUB.SELECT_ORGANIZATION, payload),
    }),
    [],
  );

  return (
    <KnowledgeHubProvider analyticsTriggers={analyticsTriggers}>
      <HubPageContent />
    </KnowledgeHubProvider>
  );
}
